import React, { useEffect, useState } from "react";
import {
  Divider,
  Grid2,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useFormik } from "formik";
import * as Yup from "yup";
import dayjs from "dayjs";
import {
  addCurrentTimeInTimeStamp,
  exportToExcel,
  getPageTitle,
  setRequiredDataForDropdown,
} from "../../common/CommonFunctions";
import { useSnackbar } from "../../contexts/Snackbar.context";
import { useBackdrop } from "../../contexts/BackDrop.context";
import { getUserRoleAndScreens } from "../../services/authServices/auth.services";
import {
  APP_MESSAGE,
  ERROR_MESSAGE,
  SNACKBAR_VARIANT,
  USE_FORMIK_SCHEMA,
} from "../../config/Messages.config";
import {
  generateAuditReport,
  generateNCReport,
  // getAllBranches,
  getAllDepartmentListByBranchId,
  getAllUsersByAccountId,
  // getAllUsersByPlantIdWithoutSuperAdmin,
  getAreasByBranchAndDept,
  getListOfAuditType,
  getListOfAuditTypeCategories,
  generateThirdPartyAuditReport,
} from "../../helpers/api-functions-helper";
import {
  auditReportDataTableColumns,
  NCReportChildDataTableColumns,
  NCReportChildDataTableColumnsForThirdParty,
  NCReportParentDataTableColumns,
  NCReportParentDataTableColumnsForThirdPartyAudits,
  select_all_obj,
  TabListConfigForReport,
} from "./components/AuditReportDataTable.config";
import { handleOutSideDataTableSearch } from "../../common/MuiTableFunctions.config";
import MUIErrorText from "../../components/MUIErrorText/MUIErrorText";
import AppInputField from "../../components/CommonReusableComponent/AppInputField/AppInputField";
import MUIDatePicker from "../../components/MUIDatePicker/MUIDatePicker";
import AppAutoCompleteField from "../../components/CommonReusableComponent/AppAutoCompleteField/AppAutoCompleteField";
import MUILoader from "../../components/MUILoader/MUILoader";
import MUITableSearch from "../../components/MUITable/MUITableSearch";
import AppButton from "../../components/CommonReusableComponent/AppButton/AppButton";
// import AuditMasterDataTable from "./components/AuditReportDataTable";
import { ROLES } from "../../config/Roles.config";
import { auditStatusConfig } from "../AuditMaster/components/AuditMasterDataTable.config";
import { thirdPartyAuditStatusConfig } from "../ThirdPartyAuditMaster/components/ThirdPartyAuditMaster.config";
import { Icons } from "../../config/MuiIcons.config";
import AuditReportDataTable_V2 from "./components/AuditReportDataTable_V2";
import { AppTheme } from "../../theme/App.theme";
import "../../ReactDataTable.Style.css";
import DataTable from "react-data-table-component";
import { exportNcReportDataToExcel } from "./components/ExportNestedNCReport";
import { exportThirdPartyAuditReportDataToExcel } from "./components/ThirdPartyNCReport";

const AuditReports = () => {
  const documentTitle = getPageTitle() && getPageTitle();
  document.title = documentTitle ? `${documentTitle} | Zing Auditor` : "Zing Auditor"
  let isMobileDevice = useMediaQuery("(max-width:599px)");
  let mediaQueryForGenerateBtn = useMediaQuery("(max-width:900px)");
  const { showSnackbar } = useSnackbar();
  const { showBackdrop, hideBackdrop } = useBackdrop();
  const { accountId, assignedBranches, assignedDepartments, role } =
    getUserRoleAndScreens();

  // States related to report data table
  const [isDataGetsLoading, setIsDataGetsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableDataInstance, setTableDataInstance] = useState([]);
  const [searchText, setSearchText] = useState("");
  // NC Report
  const [NC_Report, set_NC_report] = useState([]);
  const [NC_Report_Instance, set_NC_Report_Instance] = useState([]);

  // NC Report
  const [thirdPartyAuditReport, setThirdPartyAuditReport] = useState([]);
  const [thirdPartyAuditReportInstance, setThirdPartyAuditReportInstance] = useState([]);

  // States for all the reports related entities
  const [auditTypeCategories, setAuditTypeCategories] = useState([]);
  const [auditTypes, setAuditTypes] = useState([]);
  const [branches, setBranches] = useState([]);
  // const [All_Branches, set_All_Branches] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [areas, setAreas] = useState([]);
  const [auditorList, setAuditorList] = useState([]);
  const [auditeeList, setAuditeeList] = useState([]);

  // Global Users List
  const [AllUsers, setAllUsers] = useState([]);

  // Instance for audit types
  const [auditTypeInstance, setAuditTypeInsatnce] = useState([]);

  // Audit Status
  const [status, setStatus] = useState("All");

  // loading states
  const [loadingState, setLoadingState] = useState({
    auditTypeCategories: false,
    auditTypes: false,
    departments: false,
    branches: false,
    users: false,
    areas: false,
  });

  // Tabs state
  const [tabsValue, setTabsValue] = useState("1");

  // TabList SX (MUI - Style)
  const TabList_SX = {
    minHeight: 40,
    "& .MuiTabs-indicator": {
      backgroundColor: AppTheme.PRIMARY_COLOR,
      height: "3px",
    },
  };

  // Tab SX (MUI - Style)
  const Tab_SX = {
    minHeight: 40,
    "&.Mui-selected": {
      color: AppTheme.PRIMARY_COLOR,
      borderBottomColor: AppTheme.PRIMARY_COLOR,
    },
  };

  // All Object for selection
  const allObjWithNameId = [{ name: "All", id: "All" }];
  // const allObjWithLabelValue = [{ label: "All", value: "All" }];

  const is_SuperAdmin =
    role && role.toLowerCase() === ROLES.SUPERADMIN ? true : false;

  const isUser = role && role.toLowerCase() === ROLES.USER ? true : false;

  // Function to update loading state
  const setLoading = (key, value) => {
    setLoadingState((prev) => ({ ...prev, [key]: value }));
  };

  // Function to convert data into required payload
  const getRequiredDataSet = (
    AuditTypeCategory_Arr,
    AuditType_Arr,
    Area_Arr,
    Branch_Arr,
    Dept_Arr
  ) => {
    const auditTypeCategoryIds_Arr =
      AuditTypeCategory_Arr && AuditTypeCategory_Arr[0]
        ? AuditTypeCategory_Arr[0].label === "All"
          ? auditTypeCategories
              .filter((item) => item.value !== "All")
              .map((data) => data.value)
          : AuditTypeCategory_Arr.map((item) => item.value)
        : [];

    const auditTypeIds_Arr =
      AuditType_Arr && AuditType_Arr[0]
        ? AuditType_Arr[0].label === "All"
          ? auditTypes
              .filter((item) => item.value !== "All")
              .map((data) => data.value)
          : AuditType_Arr.map((item) => item.value)
        : [];

    const areaIds_Arr =
      Area_Arr && Area_Arr[0]
        ? Area_Arr[0].label === "All"
          ? areas
              .filter((item) => item.value !== "All")
              .map((data) => data.value)
          : Area_Arr.map((item) => item.value)
        : [];

    const branchIds_Arr =
      Branch_Arr && Branch_Arr[0]
        ? Branch_Arr[0].label === "All"
          ? branches
              .filter((item) => item.value !== "All")
              .map((data) => data.value)
          : Branch_Arr.map((item) => item.value)
        : [];

    const deptIds_Arr =
      Dept_Arr && Dept_Arr[0]
        ? Dept_Arr[0].label === "All"
          ? departments
              .filter((item) => item.value !== "All")
              .map((data) => data.value)
          : Dept_Arr.map((item) => item.value)
        : [];

    return {
      auditTypeCategoryIds_Arr,
      auditTypeIds_Arr,
      areaIds_Arr,
      branchIds_Arr,
      deptIds_Arr,
    };
  };

  // Get required users (auditee & auditors)
  const getFilteredDataOfUsers = (DATA) => {
    if (!DATA || DATA.length === 0) return { auditee: [], auditor: [] };

    const filteredData = DATA.map((user) => ({
      ...user,
      assignedBranches:
        user.assignedBranches?.filter((branch) => branch.isActive) || [],
    })).reduce(
      (acc, user) => {
        const role = user.roleName.toLowerCase();
        const formattedUser = {
          ...user,
          label: user.userName, // Adding label
          value: user.id, // Adding value
        };

        // Old Logic
        // if (role === ROLES.USER || ROLES.ADMIN) acc.auditee.push(formattedUser);
        // if (role === ROLES.USER || ROLES.ADMIN) acc.auditor.push(formattedUser);

        // Only check role conditions for auditee
        if (role === ROLES.USER || role === ROLES.ADMIN) {
          acc.auditee.push(formattedUser);
        }

        // Include all users in the auditor list (no role condition check)
        acc.auditor.push(formattedUser);

        return acc;
      },
      { auditee: [], auditor: [] }
    );

    return filteredData;
  };

  // Global loading state
  const isAllLoadingComplete = Object.values(loadingState).every(
    (status) => !status
  );

  // Fetch all active branches
  const fetchAllBranches = () => {
    const data_set =
      assignedBranches?.length > 1
        ? [...allObjWithNameId, ...assignedBranches]
        : assignedBranches;
    setRequiredDataForDropdown(setBranches, data_set, "name", "id");
  };

  // Fetch all audit type categories
  const fetchAllAuditTypeCategories = async () => {
    try {
      setLoading("auditTypeCategories", true);
      const apiResponse = await getListOfAuditTypeCategories(accountId);
      if (!apiResponse || !apiResponse.data) {
        throw new Error(ERROR_MESSAGE.FAILED_TO_FETCH_DATA);
      }

      const { statusCode, data, success, message } = apiResponse.data;

      if (!success || statusCode !== 200 || !data) {
        setAuditTypeCategories([]);
        throw new Error(message || ERROR_MESSAGE.FAILED_TO_FETCH_DATA);
      }

      let dataToBeSet = [...allObjWithNameId, ...data];
      if (data && data?.length > 1) {
        setRequiredDataForDropdown(setAuditTypeCategories, dataToBeSet, "name", "id");
      } else {
        setRequiredDataForDropdown(setAuditTypeCategories, data, "name", "id");
      }
    } catch (error) {
      console.log("Error: ", error);
      showSnackbar(ERROR_MESSAGE.FAILED_TO_FETCH_DATA, SNACKBAR_VARIANT.ERROR);
    } finally {
      setLoading("auditTypeCategories", false);
    }
  };

  // Fetch all audit types
  const fetchAllAuditTypes = () => {
    setLoading("auditTypes", true);
    getListOfAuditType(accountId)
      .then((response) => {
        if (response && response.data) {
          const { statusCode, data, success } = response.data;
          if (success && statusCode === 200) {
            let dataSet = [...allObjWithNameId, ...data];
            if (data && data?.length > 1) {
              setAuditTypeInsatnce(data)
              setRequiredDataForDropdown(setAuditTypes, dataSet, "name", "id");
            } else {
              setAuditTypeInsatnce(data)
              setRequiredDataForDropdown(setAuditTypes, data, "name", "id");
            }
          } else {
            setAuditTypes([]);
            setAuditTypeInsatnce([])
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          APP_MESSAGE.REPORT_MASTER.FETCHED.FAILED.AUDIT_TYPE,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setLoading("auditTypes", false);
      });
  };

  // Fetch all user of a selected branch
  const fetchAllUsersOfAccount = () => {
    setLoading("users", true);
    getAllUsersByAccountId(accountId)
      .then((response) => {
        if (response && response.data) {
          const { statusCode, data } = response.data;
          if (statusCode && statusCode === 200) {
            const filteredData = getFilteredDataOfUsers(data);
            const { auditee, auditor } = filteredData;
            // console.log("Auditor => ", auditor);
            // console.log("Auditee => ", auditee);
            setAllUsers(auditor);
            setAuditorList(auditor);
            setAuditeeList(auditee);
          } else {
            setAuditorList([]);
            setAuditeeList([]);
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          APP_MESSAGE.REPORT_MASTER.FETCHED.FAILED.USERS,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setLoading("users", false);
      });
  };

  // Fetch all department by branch id
  const fetchAllDepartmentByBranchId = (branches) => {
    const payload = {
      branchIds: branches,
      accountId: accountId,
    };
    setLoading("departments", true);
    getAllDepartmentListByBranchId(payload)
      .then((response) => {
        if (response && response.data) {
          const { statusCode, data } = response.data;
          if (statusCode && statusCode === 200) {
            let dataSet = [...allObjWithNameId, ...data];
            if (data && data?.length > 1) {
              setRequiredDataForDropdown(setDepartments, dataSet, "name", "id");
            } else {
              setRequiredDataForDropdown(setDepartments, data, "name", "id");
            }
          } else {
            setDepartments([]);
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          APP_MESSAGE.REPORT_MASTER.FETCHED.FAILED.DEPARTMENT,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setLoading("departments", false);
      });
  };

  // Fetch all area by department id
  const fetchAllAreaByDepartmentIdAndBranchId = (branches_, departments_) => {
    const payload = {
      accountId: accountId,
      branchIds: branches_,
      departmentIds: departments_,
    };
    setLoading("areas", true);
    getAreasByBranchAndDept(payload)
      .then((response) => {
        if (response && response.data) {
          const { statusCode, data } = response.data;
          if (statusCode && statusCode === 200) {
            let dataSet = [...allObjWithNameId, ...data];
            if (data && data?.length > 1) {
              setRequiredDataForDropdown(setAreas, dataSet, "name", "id");
            } else {
              setRequiredDataForDropdown(setAreas, data, "name", "id");
            }
          } else {
            setAreas([]);
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          APP_MESSAGE.REPORT_MASTER.FETCHED.FAILED.AREA,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setLoading("areas", false);
      });
  };

  const formatReportData = (obj, includeActivityList = false, includeActivityListForThirdParty = false) => {
    const formattedObj = {
      ...obj,
      readableStartDate: dayjs(obj.startDate).format("DD MMM YYYY"),
      readableEndDate: dayjs(obj.endDate).format("DD MMM YYYY"),
      createdAt: dayjs(obj.createdAt._seconds * 1000).format("DD MMM YYYY"),
      updatedAt: dayjs(obj.updatedAt._seconds * 1000).format("DD MMM YYYY"),
      createdAtForExcel: dayjs(obj.createdAt._seconds * 1000).format("DD MMM YYYY"),
      updatedAtForExcel: dayjs(obj.updatedAt._seconds * 1000).format("DD MMM YYYY"),
      createdByName: obj.createdByName || "Not Available",
      auditorName: obj?.auditorName  || obj?.auditorDetails?.auditorName || "Not Available",
      remark: obj?.remark  || "Not Available",
      auditTypeCategoryName: obj.auditTypeCategoryName || "Not Available"
    };
  
    if (includeActivityList) {
      formattedObj.activityList = (obj.activityList || [])
        .filter((ac) =>
          ac.complianceStatus === "Not Confirmed" ||
          ac.complianceStatus === "Area for Improvement"
        )
        .map((ac) => ({
          ...ac,
          auditorObservation: ac.auditorObservation || "Not Available",
          complianceStatus: ac.complianceStatus || "Not Available",
          capa: ac.capa || "Not Available",
          verificationStatus: ac.verificationStatus || "Not Available",
          remark: ac.remark || "Not Available",
          targetDate: ac.targetDate
            ? dayjs(ac.targetDate).format("DD MMM YYYY")
            : "Not Available",
          targetDateForExcel: ac.targetDate ? ac.targetDate : "Not Available",
        }));
    }

    if (includeActivityListForThirdParty) {
      formattedObj.ncActivities = (obj.ncActivities || [])
        .map((ac) => ({
          ...ac,
          activityName: ac.activityName || "Not Available",
          auditorObservation: ac.auditorObservation || "Not Available",
          capa: ac.capa || "Not Available",
        }));
    }
  
    return formattedObj;
  };

  const processReport = async (
    reportFunction,
    DATA,
    setInstance,   // e.g., setTableDataInstance or set_NC_Report_Instance
    setReport,     // e.g., setTableData or set_NC_report
    includeActivityList = false,
    includeActivityListForThirdParty = false
  ) => {
    setIsDataGetsLoading(true);
    try {
      const response = await reportFunction(DATA);
      if (response && response.data) {
        const { statusCode, data, message, success } = response.data;
        if (success && statusCode === 200) {
          const formattedData =
            data && data.length > 0
              ? data.map((obj) =>
                  formatReportData(
                    obj,
                    includeActivityList,
                    includeActivityListForThirdParty
                  )
                )
              : [];
          setInstance(formattedData);
          setReport(formattedData);
          return formattedData;
        } else {
          showSnackbar(
            message ||
              data ||
              APP_MESSAGE.REPORT_MASTER.FETCHED.FAILED.REPORT,
            SNACKBAR_VARIANT.ERROR
          );
          setInstance([]);
          setReport([]);
        }
      }
    } catch (error) {
      console.error("Error: ", error);
      showSnackbar(ERROR_MESSAGE.FAILED_TO_FETCH_DATA, SNACKBAR_VARIANT.ERROR);
    } finally {
      setIsDataGetsLoading(false);
    }
  };

  // Function to fetch work permit audit report
const fetchAuditReport = (DATA) => {
  processReport(
    generateAuditReport, // the API call for audit report
    DATA,
    setTableDataInstance,
    setTableData,
    false, // no extra processing of activityList
    false, // Only for third party audits
  );
};

// Function to fetch NC report
const fetchNCReport = (DATA) => {
  processReport(
    generateNCReport, // the API call for NC report
    DATA,
    set_NC_Report_Instance,
    set_NC_report,
    true, // process activityList data
    false, // Only for third party audits
  );
};

// Function to fetch NC report
const fetchThirdPartyAuditReport = (DATA) => {
  processReport(
    generateThirdPartyAuditReport, // the API call for NC report
    DATA,
    setThirdPartyAuditReportInstance,
    setThirdPartyAuditReport,
    false, // process activityList data
    true, // Only for third party audits
  );
};

  // Function used to filter data
  const getFilteredData = (filters, searchText, Data) => {
    // Apply search filter first using the existing function
    const searchFilteredData = searchText
      ? handleOutSideDataTableSearch(searchText, Data)
      : tabsValue === "1"
      ? tableDataInstance
      : tabsValue === "2"
      ? NC_Report_Instance
      : thirdPartyAuditReportInstance;

    return searchFilteredData.filter((item) => {
      return Object.keys(filters)
        .filter((key) => key !== "branchId" && key !== "departmentId") // Exclude unnecessary fields
        .every((key) => {
          if (filters[key] === "All") return true; // Ignore "All" filter
          if (!item.hasOwnProperty(key)) return false; // Exclude if key is missing
          return (
            String(item[key]).toLowerCase() ===
            String(filters[key]).toLowerCase()
          );
        });
    });
  };

  // Formik form validation for detailed audit report
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      auditTypeCategoryId: [],
      auditTypeId: [],
      branchId: [],
      departmentId: [],
      areaId: [],
      auditorId: "",
      auditeeId: "",
      fromDate: "",
      toDate: "",
    },
    validationSchema: Yup.object({
      auditTypeCategoryId: Yup.array(USE_FORMIK_SCHEMA.REPORT_MASTER.AUDIT_TYPE).of(
        Yup.object()
      ),
      auditTypeId: Yup.array(USE_FORMIK_SCHEMA.REPORT_MASTER.AUDIT_TYPE).of(
        Yup.object()
      ),
      branchId: Yup.array(USE_FORMIK_SCHEMA.REPORT_MASTER.BRANCH)
        .of(Yup.object())
        .min(1, USE_FORMIK_SCHEMA.REPORT_MASTER.BRANCH)
        .required(USE_FORMIK_SCHEMA.REPORT_MASTER.BRANCH),
      departmentId: Yup.array(USE_FORMIK_SCHEMA.REPORT_MASTER.DEPARTMENT)
      .of(Yup.object())
      .min(1, USE_FORMIK_SCHEMA.REPORT_MASTER.DEPARTMENT)
      .required(USE_FORMIK_SCHEMA.REPORT_MASTER.DEPARTMENT),
      areaId: Yup.array(USE_FORMIK_SCHEMA.REPORT_MASTER.AREA).of(Yup.object()),
      auditorId: Yup.string(),
      auditeeId: Yup.string(),
      fromDate: Yup.string().required(
        USE_FORMIK_SCHEMA.REPORT_MASTER.FROM_DATE
      ),
      toDate: Yup.string().required(USE_FORMIK_SCHEMA.REPORT_MASTER.TO_DATE),
    }),
    onSubmit: (values) => {
      const {
        auditTypeCategoryId,
        auditTypeId,
        branchId,
        departmentId,
        areaId,
        auditorId,
        auditeeId,
        fromDate,
        toDate,
      } = values;

      const { auditTypeCategoryIds_Arr, auditTypeIds_Arr, areaIds_Arr, branchIds_Arr, deptIds_Arr } =
        getRequiredDataSet(auditTypeCategoryId, auditTypeId, areaId, branchId, departmentId);

      const reportPayload = {
        auditTypeCategoryId: auditTypeCategoryIds_Arr,
        auditTypeId: auditTypeIds_Arr,
        branchIds: branchIds_Arr,
        departmentIds: deptIds_Arr,
        areaId: areaIds_Arr,
        auditorId: auditorId,
        auditeeId: auditeeId,
        fromDate: addCurrentTimeInTimeStamp(fromDate),
        toDate: addCurrentTimeInTimeStamp(toDate),
        accountId: accountId,
      };

      // console.log("permitCategory: ", permitCategory);
      // console.log("reportPayload: ", reportPayload);
      if (navigator.onLine) {
        if (auditeeId && auditorId && auditeeId === auditorId) {
          showSnackbar(
            "Auditor and Auditee cannot be the same. Please select different users.",
            SNACKBAR_VARIANT.ERROR
          );
        } else {
          if (tabsValue === "1") {
            fetchAuditReport(reportPayload);
          } else if (tabsValue === "2") {
            fetchNCReport(reportPayload);
          } else {
            const { auditorId, auditeeId, ...rest } = reportPayload;
            const revisedPayload = {
              ...rest,
              userId: reportPayload.auditeeId,
            }
            fetchThirdPartyAuditReport(revisedPayload)
          }
        }
      } else {
        showSnackbar(ERROR_MESSAGE.INTERNET_ERROR, SNACKBAR_VARIANT.ERROR);
      }
    },
  });

  useEffect(() => {
    fetchAllBranches();
    fetchAllUsersOfAccount()
    fetchAllAuditTypeCategories();
    fetchAllAuditTypes();
  }, []);

  // Outside Table search functionality
  useEffect(() => {
    if (searchText === "") {
      // Reset to original data if search text is cleared
      const filterData = getFilteredData(
        { status },
        searchText,
        tabsValue === "1"
          ? tableDataInstance
          : tabsValue === "2"
          ? NC_Report_Instance
          : thirdPartyAuditReportInstance
      );
      if (tabsValue === "1") {
        setTableData(filterData);
      } else if (tabsValue === "2") {
        set_NC_report(filterData)
      } else {
        setThirdPartyAuditReport(filterData)
      }
    } else {
      const filterData = getFilteredData(
        { status },
        searchText,
        tabsValue === "1"
          ? tableDataInstance
          : tabsValue === "2"
          ? NC_Report_Instance
          : thirdPartyAuditReportInstance
      );
      if (tabsValue === "1") {
        setTableData(filterData);
      } else if (tabsValue === "2") {
        set_NC_report(filterData)
      } else {
        setThirdPartyAuditReport(filterData)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, tabsValue]);

  useEffect(() => {
    if (tabsValue) {
      setTableData(tableDataInstance);
      set_NC_report(NC_Report_Instance)
      setThirdPartyAuditReport(thirdPartyAuditReportInstance)
      setSearchText("")
      setStatus("All")
    }
  }, [tabsValue])

  // Handle global loading state
  useEffect(() => {
    if (!isAllLoadingComplete) {
      showBackdrop();
    } else {
      hideBackdrop();
    }
  }, [isAllLoadingComplete]);

  const handleResetFieldValidation = (fieldName, value) => {
    validation.setFieldValue(fieldName, value);
    validation.setFieldTouched(fieldName, "");
  };

  const handleChangePlant = (branches) => {
    // validation.handleChange(event);
    // const { value } = event.target;
    handleResetFieldValidation("departmentId", []);
    handleResetFieldValidation("areaId", []);
    handleResetFieldValidation("auditorId", "");
    handleResetFieldValidation("auditeeId", "");
    setDepartments([]);
    setAuditeeList([]);
    setAuditorList([]);
    setAreas([]);
    if (navigator.onLine) {
      // fetchAllUsersOfAccount(branches);
      if (!isUser) {
        fetchAllDepartmentByBranchId(branches);
      } else {
        let dataSet =
          assignedDepartments?.length > 1
            ? [...allObjWithNameId, ...assignedDepartments]
            : [...assignedDepartments];
        setRequiredDataForDropdown(
          setDepartments,
          dataSet,
          "name",
          "id"
        );
      }
    } else {
      showSnackbar(ERROR_MESSAGE.INTERNET_ERROR, SNACKBAR_VARIANT.ERROR);
    }
  };

  const handleChangeForMultiSelect = (Data, FieldName) => {
    if (!Data || Data.length === 0) {
      // If no value selected, set an empty array and return
      validation.setFieldValue(FieldName, []);
      return;
    }
  
    // Determine if the first data element indicates selection of "All"
    const isAllSelected = Data[0].label === "All";
    let valueSet;
  
    // Build the list to set as the field value
    if (isAllSelected) {
      valueSet = [...select_all_obj];
    } else {
      // Remove duplicates by using a Set to keep track of unique values
      const seen = new Set();
      valueSet = Data.filter(item => {
        if (seen.has(item.value)) return false;
        seen.add(item.value);
        return true;
      });
    }
  
    // Update the field with the computed value set
    validation.setFieldValue(FieldName, valueSet);

    // Handle filteration of audit types when audit type category is changed
    if (FieldName === "auditTypeCategoryId") {
      const selectedCategories = isAllSelected
        ? auditTypeCategories.filter(cat => cat.label !== "All").map(cat => cat.value)
        : valueSet.map(cat => cat.value);

      const filteredAuditTypes = auditTypeInstance.filter(auditType =>
        selectedCategories.includes(auditType.auditTypeCategoryId)
      );

      setRequiredDataForDropdown(
        setAuditTypes,
        [...allObjWithNameId, ...filteredAuditTypes],
        "name",
        "id"
      );
    }
  
    // Handle additional changes for branch or department fields
    if (FieldName === "branchId") {
      const branchValues = isAllSelected
        ? branches.filter(br => br.label !== "All").map(br => br.value)
        : valueSet.map(br => br.value);
      handleChangePlant(branchValues);
    }
  
    if (FieldName === "departmentId") {
      // Determine branch values based on current branch selection
      const branchValues =
        validation.values.branchId[0].value === "All"
          ? branches.filter(br => br.label !== "All").map(br => br.value)
          : validation.values.branchId.map(br => br.value);
  
      // For department field, use complete list if "All" is selected; otherwise, use the unique values
      const deptValues = isAllSelected
        ? departments.filter(dr => dr.label !== "All").map(dr => dr.value)
        : valueSet.map(dr => dr.value);
  
      fetchAllAreaByDepartmentIdAndBranchId(branchValues, deptValues);
      filterUserByDept(deptValues);
    }
  };

  const disablePreviousDateForEndDate = (date) => {
    const selectedDate = dayjs(date).startOf("day");
    const minDate = dayjs(validation.values.fromDate).startOf("day");
    return selectedDate.isBefore(minDate);
  };

  const filterUserByDept = (deptIds) => {
    const users = [...AllUsers];
    const uniqueUsers = users.filter(
      (user, index, self) => index === self.findIndex((u) => u.id === user.id)
    );

    const filteredUserByDept = uniqueUsers.filter((user) => {
      return (
        // user.roleName.toLowerCase() === ROLES.ADMIN ||
        // user.roleName.toLowerCase() === "super admin" ||
        Array.isArray(user.assignedBranches) && // Ensure assignedBranches exists
        user.assignedBranches.some(
          (branch) =>
            Array.isArray(branch.assignedDepartments) && // Ensure assignedDepartments exists
            branch.assignedDepartments.some((department) =>
              deptIds.includes(department.id)
            )
        )
      );
    });

    // console.log("filteredUserByDept: ", filteredUserByDept);
    handleResetFieldValidation("auditorId", "");
    handleResetFieldValidation("auditeeId", "");
    setAuditeeList(filteredUserByDept);
    setAuditorList(uniqueUsers);
  };

  const isBranchOrDeptSelected =
    validation.values.branchId[0] && validation.values.departmentId[0]
      ? true
      : false;

  // Function to handle filter (status)
  const handleChangeStatus = (event) => {
    const { value } = event?.target;
    setStatus(value);
    const filtered_data = getFilteredData(
      { status: value },
      searchText,
      tabsValue === "1"
        ? tableDataInstance
        : tabsValue === "2"
        ? NC_Report_Instance
        : thirdPartyAuditReportInstance
    );
    if (tabsValue === "1") {
      setTableData(filtered_data);
    } else if (tabsValue === "2") {
      set_NC_report(filtered_data)
    } else {
      setThirdPartyAuditReport(filtered_data)
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <TabContext value={tabsValue}>
          <Grid2 container spacing={2}>
            <Grid2 size={{ xs: 12, sm: 9, md: 10, lg: 10 }}>
              <div style={{ borderBottom: `1px solid ${AppTheme.MUTED}` }}>
                <TabList
                  onChange={(event, newValue) => {
                    setTabsValue(newValue);
                  }}
                  sx={TabList_SX}
                  variant="scrollable"
                >
                  {TabListConfigForReport.map((itemTab, index) => (
                    <Tab
                      key={index}
                      disabled={isDataGetsLoading}
                      textColor={AppTheme.PRIMARY_COLOR}
                      indicatorColor={AppTheme.PRIMARY_COLOR}
                      sx={Tab_SX}
                      className="text-to-capitalize custom-padding-for-tabs"
                      label={itemTab.label}
                      value={itemTab.value}
                    />
                  ))}
                </TabList>
              </div>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 3, md: 2, lg: 2 }}>
              <AppButton
                Type={"submit"}
                IsDisabled={isDataGetsLoading}
                OnPress={validation.handleSubmit}
              >
                Generate Report
              </AppButton>
            </Grid2>
          </Grid2>
          <Grid2 container rowSpacing={0} columnSpacing={2}>
            <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-2">
                Select Branch <span className="mandatory-field">*</span>
              </Typography>
              {/* <AppInputField
              IsSelect={true}
              Name={"branchId"}
              Id={"branchId"}
              PlaceHolder={"Select Branch"}
              Disabled={isDataGetsLoading}
              Value={validation.values.branchId || ""}
              SelectOptions={branches || []}
              OnChange={handleChangePlant}
              OnBlur={validation.handleBlur}
              Error={
                validation.touched.branchId && validation.errors.branchId
                  ? true
                  : false
              }
              HelperText={validation.errors.branchId || ""}
            /> */}
              <AppAutoCompleteField
                Options={branches || []}
                ChipLimit={1}
                GetOptionDisabled={(option) =>
                  (validation.values.branchId.some(
                    (opt) => opt.value === "All"
                  ) &&
                    option.value !== "All") ||
                  (validation.values.branchId.some(
                    (opt) => opt.value !== "All"
                  ) &&
                    option.value === "All")
                }
                DisableCloseOnSelect={true}
                Disabled={isDataGetsLoading}
                Id={"branchId"}
                TextInputId={"branchId"}
                TextInputName={"branchId"}
                TextInputPlaceholder={"Select Branch"}
                Value={validation.values.branchId.map((type) => type)}
                HandleOnChange={(event, value) =>
                  handleChangeForMultiSelect(value, "branchId")
                }
                HandleOnBlur={validation.handleBlur}
                TextInputError={
                  validation.touched.branchId && validation.errors.branchId
                    ? true
                    : false
                }
                TextInputHelperText={
                  validation.touched.branchId && validation.errors.branchId ? (
                    <MUIErrorText ErrorMessage={validation.errors.branchId} />
                  ) : null
                }
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-2">
                Select Department <span className="mandatory-field">*</span>
              </Typography>
              {/* <AppInputField
              IsSelect={true}
              Name={"departmentId"}
              Id={"departmentId"}
              PlaceHolder={"Select Department"}
              Disabled={isDataGetsLoading}
              Value={validation.values.departmentId || ""}
              SelectOptions={departments || []}
              OnChange={(event) => {
                validation.handleChange(event);
                const { value } = event?.target;
                fetchAllAreaByDepartmentIdAndBranchId(
                  validation.values.branchId,
                  value
                );
                filterUserByDept(value);
              }}
              OnBlur={validation.handleBlur}
              Error={
                validation.touched.departmentId &&
                validation.errors.departmentId
                  ? true
                  : false
              }
              HelperText={validation.errors.departmentId || ""}
            /> */}

              <AppAutoCompleteField
                Options={departments || []}
                ChipLimit={1}
                GetOptionDisabled={(option) =>
                  (validation.values.departmentId.some(
                    (opt) => opt.value === "All"
                  ) &&
                    option.value !== "All") ||
                  (validation.values.departmentId.some(
                    (opt) => opt.value !== "All"
                  ) &&
                    option.value === "All")
                }
                DisableCloseOnSelect={true}
                Disabled={isDataGetsLoading}
                Id={"departmentId"}
                TextInputId={"departmentId"}
                TextInputName={"departmentId"}
                TextInputPlaceholder={"Select Department"}
                Value={validation.values.departmentId.map((type) => type)}
                HandleOnChange={(event, value) =>
                  handleChangeForMultiSelect(value, "departmentId")
                }
                HandleOnBlur={validation.handleBlur}
                TextInputError={
                  validation.touched.departmentId &&
                  validation.errors.departmentId
                    ? true
                    : false
                }
                TextInputHelperText={
                  validation.touched.departmentId &&
                  validation.errors.departmentId ? (
                    <MUIErrorText
                      ErrorMessage={validation.errors.departmentId}
                    />
                  ) : null
                }
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-2">
                Select Areas
              </Typography>
              <AppAutoCompleteField
                Options={areas || []}
                ChipLimit={1}
                GetOptionDisabled={(option) =>
                  (validation.values.areaId.some(
                    (opt) => opt.value === "All"
                  ) &&
                    option.value !== "All") ||
                  (validation.values.areaId.some(
                    (opt) => opt.value !== "All"
                  ) &&
                    option.value === "All")
                }
                DisableCloseOnSelect={true}
                Disabled={isDataGetsLoading}
                Id={"areaId"}
                TextInputId={"areaId"}
                TextInputName={"areaId"}
                TextInputPlaceholder={"Select Areas"}
                Value={validation.values.areaId.map((type) => type)}
                HandleOnChange={(event, value) =>
                  handleChangeForMultiSelect(value, "areaId")
                }
                HandleOnBlur={validation.handleBlur}
                TextInputError={
                  validation.touched.areaId && validation.errors.areaId
                    ? true
                    : false
                }
                TextInputHelperText={
                  validation.touched.areaId && validation.errors.areaId ? (
                    <MUIErrorText ErrorMessage={validation.errors.areaId} />
                  ) : null
                }
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-2">
                Select From Date <span className="mandatory-field">*</span>
              </Typography>
              <MUIDatePicker
                Name={"fromDate"}
                Id={"fromDate"}
                EnablePast={true}
                Value={validation.values.fromDate || ""}
                OnBlur={validation.handleBlur}
                OnChange={(e) => {
                  validation.handleChange(e);
                  validation.setFieldValue("toDate", "");
                  validation.setFieldTouched("toDate", "");
                }}
                PlaceHolder={"DD/MM/YYYY"}
                Disabled={isDataGetsLoading}
                Error={
                  validation.touched.fromDate && validation.errors.fromDate
                    ? true
                    : false
                }
                HelperText={
                  validation.touched.fromDate && validation.errors.fromDate ? (
                    <MUIErrorText ErrorMessage={validation.errors.fromDate} />
                  ) : null
                }
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-2">
                Select To Date <span className="mandatory-field">*</span>
              </Typography>
              <MUIDatePicker
                Name={"toDate"}
                EnablePast={true}
                Id={"toDate"}
                Value={validation.values.toDate || ""}
                OnBlur={validation.handleBlur}
                OnChange={validation.handleChange}
                PlaceHolder={"DD/MM/YYYY"}
                Disabled={isDataGetsLoading}
                ShouldDisableCurrentDate={disablePreviousDateForEndDate}
                Error={
                  validation.touched.toDate && validation.errors.toDate
                    ? true
                    : false
                }
                HelperText={
                  validation.touched.toDate && validation.errors.toDate ? (
                    <MUIErrorText ErrorMessage={validation.errors.toDate} />
                  ) : null
                }
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-2">
                Select Audit Type Category
              </Typography>
              <AppAutoCompleteField
                Options={auditTypeCategories || []}
                ChipLimit={1}
                GetOptionDisabled={(option) =>
                  (validation.values.auditTypeCategoryId.some(
                    (opt) => opt.value === "All"
                  ) &&
                    option.value !== "All") ||
                  (validation.values.auditTypeCategoryId.some(
                    (opt) => opt.value !== "All"
                  ) &&
                    option.value === "All")
                }
                DisableCloseOnSelect={true}
                Disabled={isDataGetsLoading}
                Id={"auditTypeCategoryId"}
                TextInputId={"auditTypeCategoryId"}
                TextInputName={"auditTypeCategoryId"}
                TextInputPlaceholder={"Select Audit Type Category"}
                Value={validation.values.auditTypeCategoryId.map(
                  (type) => type
                )}
                HandleOnChange={(event, value) => {
                  handleChangeForMultiSelect(value, "auditTypeCategoryId");
                  validation.setFieldValue("auditTypeId", []);
                }}
                HandleOnBlur={validation.handleBlur}
                TextInputError={
                  validation.touched.auditTypeCategoryId &&
                  validation.errors.auditTypeCategoryId
                    ? true
                    : false
                }
                TextInputHelperText={
                  validation.touched.auditTypeCategoryId &&
                  validation.errors.auditTypeCategoryId ? (
                    <MUIErrorText
                      ErrorMessage={validation.errors.auditTypeCategoryId}
                    />
                  ) : null
                }
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-2">
                Select Audit Types
              </Typography>
              <AppAutoCompleteField
                Options={auditTypes || []}
                ChipLimit={1}
                GetOptionDisabled={(option) =>
                  (validation.values.auditTypeId.some(
                    (opt) => opt.value === "All"
                  ) &&
                    option.value !== "All") ||
                  (validation.values.auditTypeId.some(
                    (opt) => opt.value !== "All"
                  ) &&
                    option.value === "All")
                }
                DisableCloseOnSelect={true}
                Disabled={
                  isDataGetsLoading || !validation.values.auditTypeCategoryId[0]
                }
                Id={"auditTypeId"}
                TextInputId={"auditTypeId"}
                TextInputName={"auditTypeId"}
                TextInputPlaceholder={"Select Audit Types"}
                Value={validation.values.auditTypeId.map((type) => type)}
                HandleOnChange={(event, value) =>
                  handleChangeForMultiSelect(value, "auditTypeId")
                }
                HandleOnBlur={validation.handleBlur}
                TextInputError={
                  validation.touched.auditTypeId &&
                  validation.errors.auditTypeId
                    ? true
                    : false
                }
                TextInputHelperText={
                  validation.touched.auditTypeId &&
                  validation.errors.auditTypeId ? (
                    <MUIErrorText
                      ErrorMessage={validation.errors.auditTypeId}
                    />
                  ) : null
                }
              />
            </Grid2>
            {tabsValue !== "3" && (
              <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
                <Typography variant="body2" className="inter-regular-400 py-2">
                  Select Auditor
                </Typography>
                <AppAutoCompleteField
                  IsMultiple={false}
                  TextInputName={"auditorId"}
                  TextInputId={"auditorId"}
                  Id={"auditorId"}
                  TextInputPlaceholder={"Select Auditor"}
                  Options={auditorList || []}
                  Disabled={isDataGetsLoading || !isBranchOrDeptSelected}
                  Value={validation.values.auditorId || ""}
                  HandleOnBlur={validation.handleBlur}
                  HandleOnChange={(event, value) => {
                    const event_ = {
                      ...event,
                      target: {
                        ...event?.target,
                        value: value?.value || "",
                        name: "auditorId",
                        id: "auditorId",
                      },
                    };
                    validation.handleChange(event_);
                  }}
                  TextInputError={
                    validation.touched.auditorId && validation.errors.auditorId
                      ? true
                      : false
                  }
                  TextInputHelperText={validation.errors.auditorId}
                />
              </Grid2>
            )}
            <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <Typography variant="body2" className="inter-regular-400 py-2">
                {tabsValue !== "3"
                  ? "Select Auditee"
                  : "Select Auditee or User"}
              </Typography>
              <AppAutoCompleteField
                IsMultiple={false}
                TextInputName={"auditeeId"}
                TextInputId={"auditeeId"}
                Id={"auditeeId"}
                TextInputPlaceholder={
                  tabsValue !== "3"
                    ? "Select Auditee"
                    : "Select Auditee or User"
                }
                Options={auditeeList || []}
                Disabled={isDataGetsLoading || !isBranchOrDeptSelected}
                Value={validation.values.auditeeId || ""}
                HandleOnBlur={validation.handleBlur}
                HandleOnChange={(event, value) => {
                  const event_ = {
                    ...event,
                    target: {
                      ...event?.target,
                      value: value?.value || "",
                      name: "auditeeId",
                      id: "auditeeId",
                    },
                  };
                  validation.handleChange(event_);
                }}
                TextInputError={
                  validation.touched.auditeeId && validation.errors.auditeeId
                    ? true
                    : false
                }
                TextInputHelperText={validation.errors.auditeeId}
              />
            </Grid2>
          </Grid2>
          <Divider
            style={{ color: "GrayText", border: "0.02rem solid GrayText" }}
            className="my-2"
          />
          <Grid2 container className="mt-3" spacing={2}>
            {isDataGetsLoading ? (
              <MUILoader />
            ) : (
              <>
                <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
                  <MUITableSearch
                    CancelSearch={() => {
                      setSearchText("");
                    }}
                    HandleSearch={(e) => setSearchText(e.target.value)}
                    SearchText={searchText}
                  />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
                  <AppInputField
                    Name={"status"}
                    Id={"status"}
                    IsSelect={true}
                    StartAdornmentForSelect={
                      <IconButton className="p-1">
                        <Icons.FilterAltOutlinedIcon color="inherit" />
                      </IconButton>
                    }
                    Value={status}
                    SelectOptions={
                      tabsValue === "3"
                        ? thirdPartyAuditStatusConfig
                        : auditStatusConfig || []
                    }
                    Label={"Select audit status"}
                    OnChange={handleChangeStatus}
                  />
                </Grid2>
                <Grid2
                  size={{ xs: 12, sm: 3, md: 2, lg: 2 }}
                  className="ms-auto"
                >
                  {tabsValue === "1" ? (
                    <AppButton
                      Type={"button"}
                      IsDisabled={!tableDataInstance[0]}
                      OnPress={() => {
                        exportToExcel(
                          tableDataInstance,
                          auditReportDataTableColumns,
                          `Internal_Audit_Report`
                        );
                      }}
                      children={"Export To Excel"}
                    />
                  ) : tabsValue === "2" ? (
                    <AppButton
                      Type={"button"}
                      IsDisabled={!NC_Report_Instance[0]}
                      OnPress={() => {
                        exportNcReportDataToExcel(
                          NC_Report_Instance,
                          // NCReportParentDataTableColumns,
                          // `NC_Report_Of_Internal_Audit`
                        );
                      }}
                      children={"Export To Excel"}
                    />
                  ) : (
                    <AppButton
                      Type={"button"}
                      IsDisabled={!thirdPartyAuditReport[0]}
                      OnPress={() => {
                        // exportToExcel(
                        //   thirdPartyAuditReportInstance,
                        //   NCReportParentDataTableColumnsForThirdPartyAudits,
                        //   `Third_Party_Audit_Report`
                        // );
                        exportThirdPartyAuditReportDataToExcel(
                          thirdPartyAuditReportInstance,
                        );
                      }}
                      children={"Export To Excel"}
                    />
                  )}
                </Grid2>
                {tabsValue === "1" ? (
                  <Grid2 size={12}>
                    <AuditReportDataTable_V2 Rows={tableData || []} />
                  </Grid2>
                ) : tabsValue === "2" ? (
                  <Grid2 size={12}>
                    <div className="mb-2">
                      <Typography variant="caption">
                        <strong>Note:</strong> NC's = (Not Confirmed + Area Of
                        Improvement)
                      </Typography>
                    </div>
                    <div
                      className="box-elevation-1 p-0"
                      style={{
                        borderBottomLeftRadius: "5px",
                        borderBottomRightRadius: "5px",
                      }}
                    >
                      <DataTable
                        progressPending={isDataGetsLoading}
                        data={NC_Report || []}
                        columns={NCReportParentDataTableColumns}
                        persistTableHead
                        expandOnRowClicked
                        pagination
                        expandableRows={true}
                        expandableRowExpanded={() => true}
                        noDataComponent={<NoDataComponent />}
                        expandableRowsComponent={NestedSummaryReportDataTable}
                      />
                    </div>
                  </Grid2>
                ) : (
                  <Grid2 size={12}>
                    <div
                      className="box-elevation-1 p-0"
                      style={{
                        borderBottomLeftRadius: "5px",
                        borderBottomRightRadius: "5px",
                      }}
                    >
                      <DataTable
                        progressPending={isDataGetsLoading}
                        data={thirdPartyAuditReport || []}
                        columns={
                          NCReportParentDataTableColumnsForThirdPartyAudits
                        }
                        persistTableHead
                        expandOnRowClicked
                        pagination
                        expandableRows={true}
                        expandableRowExpanded={() => true}
                        noDataComponent={<NoDataComponent />}
                        expandableRowsComponent={
                          NestedSummaryReportDataTableForThirdPartyAudit
                        }
                      />
                    </div>
                  </Grid2>
                )}
              </>
            )}
          </Grid2>
        </TabContext>
      </div>
    </React.Fragment>
  );
};

// Nested summary report component for internal audits
const NestedSummaryReportDataTable = (Data) => {
  return (
    <div className="px-4 pt-2 pb-3">
      <Typography variant="subtitle2" className="inter-regular-400 my-2">
        NC Activities
      </Typography>
      <div
        className="box-elevation-1 p-0"
        style={{
          borderBottomLeftRadius: "5px",
          borderBottomRightRadius: "5px",
        }}
      >
        <DataTable
          data={Data.data.activityList}
          persistTableHead
          noDataComponent={<NoDataComponent />}
          columns={NCReportChildDataTableColumns || []}
        />
      </div>
    </div>
  );
};

// Nested summary report component for internal audits
const NestedSummaryReportDataTableForThirdPartyAudit = (Data) => {
  return (
    <div className="px-4 pt-2 pb-3">
      <Typography variant="subtitle2" className="inter-regular-400 my-2">
        NC Activities
      </Typography>
      <div
        className="box-elevation-1 p-0"
        style={{
          borderBottomLeftRadius: "5px",
          borderBottomRightRadius: "5px",
        }}
      >
        <DataTable
          data={Data.data.ncActivities}
          persistTableHead
          noDataComponent={<NoDataComponent />}
          columns={NCReportChildDataTableColumnsForThirdParty || []}
        />
      </div>
    </div>
  );
};

// No Data component
const NoDataComponent = () => {
  return (
    <div className="w-100 d-flex align-items-center justify-content-center">
      <Typography
        variant="subtitle2"
        className="inter-regular-400 my-3 text-center"
        fontSize={12}
      >
        There are no records to display
      </Typography>
    </div>
  );
};

export default AuditReports;
